/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconHalberd: {
  name: 'halberd';
  data: string;
} = {
  name: 'halberd',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M500.488 345.597c67.774-86.609 105.285-198.2 99.448-321.717l-.003.002c-82.564 91.116-248.775 65.737-316.97-2.465L193.622 60.33l57.704 57.702-71.842 71.67-57.616-57.614-33.566 83.992c10.293 10.292 19.62 22.811 27.756 36.897l-92.176 91.955v106.109l121.041-120.796c14.742 70.489 3.753 150.086-48.816 197.464 110.682 3.438 211.438-26.219 293.301-79.983l108.903 6.702 2.177-108.831zM232.564 242.781l71.829-71.683 26.071 26.07c19.799 19.792 19.799 51.961-.002 71.761-19.801 19.8-51.958 19.795-71.754-.005l-26.144-26.143z"/></svg>`,
};
